import ArrayList from "./ArrayList";
import CouponBase from "./Coupon";
import CartruleBase from "./CartruleBase";
import * as moment from "moment";

class Cartrule extends CartruleBase {
    constructor(options) {
        super(options);
        (this as any).coupons = d => {
          return new ArrayList<CouponBase>(CouponBase, d.data);
        };
        this.bind(options);
    }
    getCartruleValidFrom(): moment.Moment {
      let m = moment(this['valid_from']);
      return m;
    }
    getCartruleValidTo(): moment.Moment {
      let m = moment(this['valid_to']);
      return m;
    }
}

export default Cartrule;
